import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {
  get(name: string): string {
    const nameEQ = encodeURIComponent(name) + '=';
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const c = cookie.trimStart();
      if (c.startsWith(nameEQ)) {
        return decodeURIComponent(c.substring(nameEQ.length));
      }
    }
    return '';
  }

  set(name: string, value: string, options?: {
    expires?: Date;
    path?: string;
    secure?: boolean;
    sameSite?: string;
  }): void {
    let cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);
    if (options?.expires) {
      cookie += '; expires=' + options.expires.toUTCString();
    }
    if (options?.path) {
      cookie += '; path=' + options.path;
    }
    if (options?.secure) {
      cookie += '; secure';
    }
    if (options?.sameSite) {
      cookie += '; samesite=' + options.sameSite;
    }
    document.cookie = cookie;
  }
}
